module.exports = __webpack_public_path__ + "0e04541b6ebe474c81733ab05f85b891.png";